
<ngx-spinner bdColor="rgba(0,0,0,0)"
             size="medium"
             color="#000000"
             type="ball-spin-clockwise">
</ngx-spinner>
<div class="modal-content modal-content-width border-all-10px-modal">
  <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


    <div class="card-header wh-header border-bottom padding-bottom-5px padding-left-15px padding-right-15px">
      <div class="row nav-tab-service2">
        <div class="col-md-11">
          <ul class="nav nav-tabs" id="tabContent">
            <li class="active margin-right-15px"><a class="nav-itemerp active" href="#AddPartner" data-toggle="tab">Add Partner</a></li>
            <li class="margin-right-15px"><a class="nav-itemerp" href="#LinkPartner" data-toggle="tab">Link Partner</a></li>

          </ul>

        </div>
        <div class="col-md-1 padding-left-0px">
          <button type="button" class="close" data-dismiss="modal"
                  (click)="activeModal.close('Cross click')"
                  aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>

        </div>
      </div>




    </div>

    <div class="modal-body padding-top-0px counselling-modal">

      <div class="tab-content">
        <div class="tab-pane active" id="AddPartner">
          <form class="form" novalidate="" #f="ngForm">
            <div class="card">
              <div class="card-body padding-bottom-0px">
                <div>
                  <div class="row">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                      <div class="row">
                        <div class="col-md-5 text-align-right">
                          <label for="firstName" class="margin-bottom-0px margin-top-3px">
                            Existing Patient Name
                          </label>
                        </div>
                        <div class="col-md-3">
                          <label class="margin-bottom-0px">{{CurrentSavePatientInfoRequest.DisplayName}}</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                      <div class="row">
                        <div class="col-md-5 text-align-right">
                          <label for="firstName" class="margin-bottom-0px margin-top-3px">
                            Existing Patient FormattedCode
                          </label>
                        </div>
                        <div class="col-md-3">
                          <label class="margin-bottom-0px">{{FormattedCode}}</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                      <div class="row">
                        <div class="col-md-5 text-align-right">
                          <label for="firstName" class="margin-bottom-0px margin-top-3px">
                            <span>*</span>Salutation (Name Prefix)
                          </label>
                        </div>
                        <div class="col-md-3">
                          <CodeTypeValue CodeType="NPRE" id="PartnerSalutation"
                                         [(ngModel)]="PartnerSalutation" SelectedValue=""
                                         name="PartnerSalutation" required>
                          </CodeTypeValue>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row my-profile-form">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                      <div class="row">
                        <div class="col-md-5 text-align-right">
                          <label for="firstName" class="label-size margin-bottom-0px margin-top-3px"><span>*</span>Partner Name </label>
                        </div>
                        <div class="col-md-3">
                          <input type="text" class="form-control" placeholder="First Name"
                                 id="PartnerDisplayName"
                                 [(ngModel)]="PartnerDisplayName"
                                 name="PartnerDisplayName" pattern="^[\sa-zA-Z,._\-?]*$"
                                 maxlength="30" minlength="1" #DisplayName="ngModel" required>
                          <small class="form-text text-danger"
                                 *ngIf="(!DisplayName.valid && (DisplayName.dirty || DisplayName.touched) && DisplayName.errors.required )">(Field cannot be left blank)</small>
                          <small class="form-text text-danger"
                                 *ngIf="(!DisplayName.valid && DisplayName.errors.pattern)">(special characters are not allowed)</small>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                      <div class="row">
                        <div class="col-md-5 text-align-right">
                          <label for="birthDate" class="label-size margin-bottom-0px margin-top-3px"><span>*</span> Date of Birth  </label>
                        </div>
                        <div class="col-md-3">
                          <div class="date-form">
                            <input type="text" class="form-control form-control-patient" placeholder="Date Of Birth"
                                   name="dp" [(ngModel)]="PartnerDateOfBirth" ngbDatepicker [minDate]="{year: 1900, month: 1, day: 1}" required #d6="ngbDatepicker" #DOBin="ngModel">
                            <small class="form-text text-danger"
                                   *ngIf="(!DOBin.valid && (DOBin.dirty || DOBin.touched) && DOBin.errors.required)">(Field cannot be left blank)</small>

                            <a (click)="d6.toggle()" class="nav-link-hand">
                              <span class="date-icon"><i class="far fa-calendar-alt"></i></span>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row my-profile-form">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                      <div class="row">
                        <div class="col-md-5 text-align-right">
                          <label for="diaplayName" class="label-size margin-bottom-0px margin-top-3px"><span>*</span> Sex</label>
                        </div>
                        <div class="col-md-3">
                          <CodeTypeValue CodeType="Sex"
                                         id="PartnerGender"
                                         [(ngModel)]="PartnerGender" SelectedValue=""
                                         name="PartnerGender" required>
                          </CodeTypeValue>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                      <div class="row">
                        <div class="col-md-5 text-align-right">
                          <label for="diaplayName" class="label-size margin-bottom-0px margin-top-3px"><span>*</span> Contact Number </label>
                        </div>
                        <div class="col-md-3">
                          <input type="tel" class="form-control" placeholder="Mobile Phone"
                                 id="PartnerMobileNumber"
                                 [(ngModel)]="PartnerMobileNumber"
                                 name="PartnerMobileNumber"
                                 maxlength="25" minlength="1" #Telephone1="ngModel">
                        </div>
                      </div>


                    </div>
                  </div>

                </div>
              </div>
              <div class="card-footer">
                <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px float-right"
                        (click)="activeModal.close('Close click')">
                  Close
                </button>
                <button type="submit" (click)="AddPartner()"
                        class="btn actions-btn-prime float-right font-size-13px margin-right-10px">
                  Save
                </button>
              </div>
            </div>
          </form>
        </div>


        <div class="tab-pane" id="LinkPartner">
          <form class="form" novalidate="" #f="ngForm">
            <div class="card">
              <div class="card-body padding-bottom-0px">
                <div>
                  <div class="row">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                      <div class="row">
                        <div class="col-md-5 text-align-right">
                          <label for="firstName" class="margin-bottom-0px margin-top-3px">
                            Existing Patient Name
                          </label>
                        </div>
                        <div class="col-md-3">
                          <label class="margin-bottom-0px">{{CurrentSavePatientInfoRequest.DisplayName}}</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                      <div class="row">
                        <div class="col-md-5 text-align-right">
                          <label for="firstName" class="margin-bottom-0px margin-top-3px">
                            Existing Patient FormattedCode
                          </label>
                        </div>
                        <div class="col-md-3">
                          <label class="margin-bottom-0px">{{FormattedCode}}</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                      <div class="row">
                        <div class="col-md-5 text-align-right">
                          <div class="display-inline">
                            Select Patient <button 
                                                    type="button" (click)="SelectSpouse()"
                                                    class="btn btn-secondary font-size-13px btn-raised button-Schedule action-button-prime-cycle actions-btn-prime3">
                              <i class="fas fa-ellipsis-h"></i>
                            </button>
                            
                          </div>
                          </div>
                          <div class="col-md-6">                            
                              <label class="margin-bottom-0px">{{PartnerName}}</label>
                          </div>
                        </div>
                    </div>
                  </div>
                  

                </div>
              </div>
              <div class="card-footer">
                <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px float-right"
                        (click)="activeModal.close('Close click')">
                  Close
                </button>
                <button type="submit" (click)="LinkPartner()"
                        class="btn actions-btn-prime float-right font-size-13px margin-right-10px">
                  Save
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

